import React from 'react';
import { Modal, Spin, Alert } from 'antd';
import {
  LoadingOutlined,
} from '@ant-design/icons';
import Alerts from '../../components/alerts/Alerts';
import { connect } from 'react-redux';
import { CLEAR_ERRORS } from '../../state/error/types';
import PropTypes from 'prop-types';

const spinnerIcon = <LoadingOutlined style={{ fontSize: 50 }} spin />;

const ModalRejectObjection = ({ ...props }) => {
  return (
    <Modal
      visible={props.visible}
      title="Rechazar objeción de contrato"
      okText="Rechazar"
      cancelText="Cancelar"
      maskClosable={false}
      onCancel={props.onCancel}
      afterClose={() => props.clearErrors()}
      onOk={() => props.onCreate()}
      okButtonProps={{ disabled: props.spinning }}
      cancelButtonProps={{ disabled: props.spinning }}
    >
      <Spin
        spinning={props.spinning}
        size="large"
        indicator={spinnerIcon}
      >
        <Alerts />
        <Alert
          message="Está a punto de rechazar la objeción"
          description="Se notificará a las partes correspondientes el rechazo de la objeción realizada en este contrato."
          type="info"
          showIcon
        />
      </Spin>
    </Modal>
  );
};

ModalRejectObjection.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  spinning: PropTypes.bool.isRequired,
  spinnerIcon: PropTypes.object.isRequired,
};

const action = (dispatch) => ({
  clearErrors: () => dispatch({ type: CLEAR_ERRORS }),
});

export default connect(null, action)(ModalRejectObjection);